import { type ReactNode } from 'react'
import { Lock } from 'lucide-react'
import { Text } from '@/components/ui/Text'

interface SectionPermissionGuardProps {
  canRead: boolean
  children: ReactNode
}

/**
 * Renders a no-access state when canRead=false.
 * Must NOT reveal record existence or count (T16 no-leak).
 */
export function SectionPermissionGuard({ canRead, children }: SectionPermissionGuardProps) {
  if (!canRead) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <Lock size={24} className="text-text-subtle mb-3" />
        <Text variant="body-md" color="muted">You don&apos;t have access to this section.</Text>
      </div>
    )
  }
  return <>{children}</>
}
